import { render } from "./JobDetailsView.vue?vue&type=template&id=85b173c0&scoped=true"
import script from "./JobDetailsView.vue?vue&type=script&lang=js"
export * from "./JobDetailsView.vue?vue&type=script&lang=js"

import "./JobDetailsView.vue?vue&type=style&index=0&id=85b173c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85b173c0"]])

export default __exports__